import {throttle, getUrlVars, scrollToElement} from "./Util";
import {
    reSliderAjax
} from '../swiper-configs';

let storePromise;

const delta = App.mobile ? 115 : 250;

let isCleanSearch = true;

if ($('.js-products-filter-form').length) {

    $('.js-products-filter-form').each(function() {
        let $productsFilterForm = $(this);
        let $productFilterQuantity = $productsFilterForm.find('.js-product-filter-quantity');
        let $productFilterName = $productsFilterForm.find('.js-product-filter-name');
        let $productsFilterSelect = $productsFilterForm.find('.js-products-filter-select');
        let $productFilterResults = $productsFilterForm.find('.js-product-filter-results');
        let $productFilterQuantityClose = $productsFilterForm.find('.js-product-filter-quantity-close');
        let $productsFilterFields = $productsFilterForm.find('.js-product-filter-field');
        let $productFilterSearchResults = $productsFilterForm.find('.js-filter-search');
        let productDefaultValues = [];

        // new filter
        let $productFilterInput = $productsFilterForm.find('.js-product-filter-input');
        let $filterTooltipPopular = $productsFilterForm.find('.js-filter-tooltip-popular');
        let $filterTooltipResults = $productsFilterForm.find('.js-filter-tooltip-results');

        $productsFilterForm.on('submit', function (e) {
            if ($productsFilterForm.is('._disabled') || ($productFilterInput.is('.js-search-field') && $productFilterInput.val() === '')) {
                e.preventDefault();
            }
        });

        $productFilterInput.on('focus', function () {
            if(isCleanSearch){
                if(!$(this).parents('.products-filter__item').length){
                    $(this).addClass('_focus')
                    $('.header__logo').addClass('_focus');
                    $('.header__description').addClass('_focus');
                    $('.mobile-menu__top').addClass('_focus');
                    $('.mobile-menu__bottom').addClass('_focus');
                    $('.js-search').addClass('_focus');
                    $('body').css('overflow', 'hidden');
                }
                $('.js-filter-search').removeClass('_active');
                if ($(this).siblings('.js-filter-search').length) {
                    $(this).siblings('.js-filter-search').addClass('_active');
                }
            }
        });

        App.B.on('click', function(e){
            if (!$(e.target).closest('.js-filter-search, .js-product-filter-name').length){
                $('.js-filter-search').removeClass('_active');
            }
        });

        $productFilterName.on('input', function () {
            const that = $(this);
            if($(this).val().length > 2){
                if(!$('[data-search-clean]').length){
                    if(!$(this).parents('.products-filter__item').length){
                        $('[data-header-search-btn-clean]').append('<div data-search-clean class="search__btn-clean"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.1752 6.17569C6.63082 5.72008 7.36951 5.72008 7.82512 6.17569L21.8251 20.1757C22.2807 20.6313 22.2807 21.37 21.8251 21.8256C21.3695 22.2812 20.6308 22.2812 20.1752 21.8256L6.1752 7.82561C5.71959 7.37 5.71959 6.6313 6.1752 6.17569Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M21.8253 6.17569C21.3697 5.72008 20.631 5.72008 20.1754 6.17569L6.17537 20.1757C5.71976 20.6313 5.71976 21.37 6.17537 21.8256C6.63098 22.2812 7.36967 22.2812 7.82528 21.8256L21.8253 7.82561C22.2809 7.37 22.2809 6.6313 21.8253 6.17569Z" fill="currentColor"></path></svg><div>')
                        $('[data-search-clean]').on('click', function(e){
                            isCleanSearch = false
                            if(!$('.js-search').hasClass('_focus')){
                                setTimeout(()=>{
                                    that[0].blur()
                                }, 200)
                            }
                            setTimeout(()=>{
                                isCleanSearch = true
                            }, 100)
                            e.stopPropagation()
                            that.val('')
                            $('[data-search-clean]').remove()
                            inputProductName();
                            checkFilterFields();
                        })
                    }
                }
            } else {
                if(!$(this).parents('.products-filter__item').length) {
                    $('[data-search-clean]').remove()
                }
            }
            inputProductName();
            checkFilterFields();
        });

        $productsFilterSelect.on('change', function () {
            getProductsCount();
            checkFilterFields();
        });

        $productFilterName.on('keyup', function(e) {
            if(e.keyCode == 13) {
                getProductsCount();
                checkFilterFields();
                $productsFilterForm.submit();
            }
        });

        $productFilterQuantityClose.on('click', function (e) {
            $productFilterQuantity.removeClass('_show');

            e.preventDefault();
        });

        App.H.on('click', '.js-click-text', function () {
            $productFilterName.val($(this).find('.js-click-text-span').html());
            $productsFilterForm.submit();
        });

        App.H.on('click', function (e) {
            if (!$productFilterResults.is(e.target) && $productFilterResults.has(e.target).length === 0) {
                $productFilterResults.removeClass('_show');
            }
        });

        // Поиск по быстрым ссылкам
        App.H.on('click', '.js-fast-search', function (e) {
            e.preventDefault();

            let $link = $(this);
            let $productsFilterForm = $link.closest('.js-products-filter-form');
            let $productFilterInput = $productsFilterForm.find('.js-product-filter-input');

            $productFilterInput.val($link.text());
            $productsFilterForm.removeClass('_disabled').submit();
        });

        getDefaultFilterValues();

        let tempTimer;

        const inputProductName = throttle(() => {
            if ($productFilterName.val().length > 3) {
                clearTimeout(tempTimer);
                $productsFilterForm.addClass('_loading');

                if ($productFilterName.hasClass('js-product-filter-input')) {
                    tempTimer = setTimeout(getProductsResults, 750);
                } else {
                    getProductsResults();
                }
            } else {
                $productFilterResults.removeClass('_show');
                $filterTooltipResults.removeClass('_show');
                $filterTooltipPopular.addClass('_show');
            }
        }, 500);

        function checkFilterFields() {
            let currValuesArr = [];

            $productsFilterFields.each(function (index, el) {
                let $currField = $(el);

                currValuesArr.push($currField.val());
            });

            // если значения остались такие же, то блочим форму
            if (currValuesArr.filter(value => productDefaultValues.includes(value)).length === $productsFilterFields.length) {
                $productsFilterForm.addClass('_disabled');
            } else {
                $productsFilterForm.removeClass('_disabled');
            }
        }

        function getDefaultFilterValues() {
            $productsFilterFields.each(function (index, el) {
                let $currField = $(el);

                productDefaultValues.push($currField.val());
            });
        }

        function getProductsCount() {
            $.ajax({
                url: $productsFilterForm.data('count-url'),
                method: $productsFilterForm.attr('method') || 'GET',
                data: $productsFilterForm.serialize(),
                success: (response) => {
                    $productFilterQuantity.find('.js-product-filter-quantity-count').html(response.quantity);
                    $productFilterQuantity.addClass('_show');
                    $productFilterResults.removeClass('_show');
                },
                error: () => {
                    console.log('Ошибка получения данных');
                }
            });
        }

        function getProductsResults() {
            $.ajax({
                url: $productsFilterForm.data('search-url'),
                method: $productsFilterForm.attr('method') || 'GET',
                data: $productsFilterForm.serialize(),
                success: (response) => {
                    $productsFilterForm.removeClass('_loading');

                    $productFilterResults
                        .html(response.results)
                        .addClass('_show');

                    $productFilterQuantity.removeClass('_show');

                    $filterTooltipResults
                        .html(response.results)
                        .addClass('_show');

                    $filterTooltipPopular.removeClass('_show');

                    if (document.querySelectorAll('.re-slider-ajax')[0]) {
                        setTimeout(function () {
                            if (reSliderAjax) {
                                reSliderAjax.init();
                            }
                        }, 100);
                    }
                },
                error: () => {
                    console.log('Ошибка получения данных');
                }
            });
        }
    });
}

App.D.ready(function() {
    if (App.H.hasClass('page-products-store') && App.H.find('.js-catalog-with-pages').length) {
        /*setTimeout(() => {*/
            // для перехода по крошкам надо попадать в начало каталога по параметру в урле
            // поэтому проверяем параметр page в урле, если он =1, то убираем pageId в сторадже
            if (getUrlVars(window.location.href)['page'] && parseInt(getUrlVars(window.location.href)['page']) === 1) {
                localStorage.removeItem('pageId');
            }

            let currPage = (window.localStorage.getItem('pageId')) ?
                            window.localStorage.getItem('pageId') :
                            getUrlVars(window.location.href)['page'];
            currPage = currPage || 1;
            let $moreContainer = $('.js-catalog-with-pages');

            let $pagination = $('.js-catalog-pagination');
            let $paginationCurr = $pagination.find('.js-catalog-curr-page');
            let $paginationPrev = $pagination.find('.js-show-prev-items');

            if (currPage) {
                if (currPage !== 1) {
                    $('html, body').animate({'scrollTop': $moreContainer.offset().top - delta}, 10);
                }

                $moreContainer.find('.js-store-product:not([data-page])').each(function() {
                    $(this).attr('data-page', currPage);
                });

                $('.js-more-page').val(currPage);

                if (currPage - 1 > 0) {
                    $pagination.removeClass('_hidden');
                    $paginationCurr.text(currPage);

                    if (window.location.href.indexOf('?') > 0) {
                        let params = new URLSearchParams(window.location.search);
                        let page = params.get('page');

                        if (page) {
                            params.set('page', currPage - 1);
                            $paginationPrev.attr('href', '?' + params);
                        } else {
                            $paginationPrev.attr('href', '?' + params + '&page=' + (currPage - 1));
                        }
                    } else {
                        $paginationPrev.attr('href', `?page=${currPage - 1}`);
                    }
                }

                if (!storePromise && document.querySelector('.js-store-product, .js-slider-products-store, .js-products-wrapper')) {
                    storePromise = import('/_src/js/store/_store.js');
                }
                storePromise.then(({productQuantity, productsSliderSync, userFavouriteProducts}) => {
                    productQuantity();
                    productsSliderSync();
                    userFavouriteProducts();
                });

                const productId = window.localStorage.getItem('productId');

                /*console.log('productId---', productId);*/

                if ($moreContainer.find(`.js-store-product[data-product-id="${productId}"]`).length) {
                    const $needProduct = $moreContainer.find(`.js-store-product[data-product-id="${productId}"]`);
                    /*console.log('1000-productId-top-', $needProduct.offset().top);*/

                    /*setTimeout(() => {
                        console.log('test load scroll timeout 500');
                        scrollToElement($('.js-store-product[data-product-id="' + window.localStorage.getItem('productId') + '"]'));
                    }, 500);*/
                    /*scrollToElement($('.js-store-product[data-product-id="' + window.localStorage.getItem('productId') + '"]'));*/

                    setTimeout(function () {
                        $('html, body').animate({'scrollTop': $needProduct.offset().top - delta}, 300);

                        /*localStorage.removeItem('productId');
                        localStorage.removeItem('pageId');*/
                    }, 1000);

                }

                setTimeout(() => {
                    localStorage.removeItem('productId');
                    localStorage.removeItem('pageId');
                }, 1000);


                /*$.ajax({
                    url: $moreContainer.data('url'),
                    method: $moreContainer.data('type'),
                    data: `page=${currPage}`,
                    success: (response) => {
                        console.log('ajax success');

                        $moreContainer.html($(response).html());
                        scrollToElement($moreContainer);

                        $('.js-more-page').val(currPage);

                        if (currPage - 1 > 0) {
                            $pagination.removeClass('_hidden');
                            $paginationCurr.text(currPage);
                            $paginationPrev.attr('href', `?page=${currPage - 1}`);
                        }

                        if ($(response).hasClass('_no-more-load')) {
                            $moreContainer.addClass('_no-more-load');
                        }

                        productQuantity();
                        productsSliderSync();
                        userFavouriteProducts();

                        if (window.localStorage.getItem('productId')) {
                            console.log('test load scroll');

                            setTimeout(() => {
                                console.log('test load scroll timeout 500');
                                scrollToElement($('.js-store-product[data-product-id="' + window.localStorage.getItem('productId') + '"]'));
                            }, 500);
                        }

                        setTimeout(() => {
                            localStorage.removeItem('productId');
                            localStorage.removeItem('pageId');
                        }, 2000);
                    },
                    error: () => {
                        console.log('Ошибка получения данных фильтра');
                        $moreContainer.removeClass('_loading');
                    }
                });*/
            } else {
                $pagination.addClass('_hidden');
            }
        /*}, 500);*/

        App.D.on('click', '.js-catalog-with-pages .js-store-product .product-item__wrap', function () {
            localStorage.removeItem('productId');
            localStorage.removeItem('pageId');
            $moreContainer.addClass('_product-clicked');

            let $product = $(this).closest('.js-store-product');
            let pageId = $product.attr('data-page') || 0;
            let productId = $product.attr('data-product-id') || 0;

            window.localStorage.setItem('pageId', `${pageId}`);
            window.localStorage.setItem('productId', `${productId}`);

            let baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            // let newUrl = baseUrl + '?page=' + pageId;
            // let baseUrl = window.location;
            let newUrl;

            if (window.location.href.indexOf('?') > 0) {
                let params = new URLSearchParams(window.location.search);
                let page = params.get('page');

                if (page) {
                    params.set('page', pageId);
                    newUrl = baseUrl + '?' + params;
                } else {
                    newUrl = baseUrl + '?' + params + '&page=' + pageId;
                }
            } else {
                newUrl = baseUrl + '?page=' + pageId;
            }

            history.pushState(null, null, newUrl);
        });

        if (App.H.find('.js-filter-search-mobile')) {
            if (App.W.outerWidth() < 768) {
                $('.js-filter-search-mobile').find('.js-input').removeAttr('disabled');
            } else {
                $('.js-filter-search-mobile').find('.js-input').attr('disabled', true);
            }
        }

        App.H.on('keyup', '.js-filter-search-mobile .js-input', function(e) {
            e.preventDefault();

            if (e.keyCode == 13) {
                let val = $(this).val();
                $('.js-common-popup').find('.js-product-filter-name').val(val);
                $('.js-common-popup').find('.js-products-filter-form').removeClass('_disabled')
                                    .find('.button').trigger('click');
            }
        });

        App.H.on('click', '.js-filter-search-mobile .search-btn', function(e) {
            let val = $(this).closest('.js-filter-search-mobile').find('.js-input').val();
            $('.js-common-popup').find('.js-product-filter-name').val(val);
            $('.js-common-popup').find('.js-products-filter-form').removeClass('_disabled')
                                .find('.button').trigger('click');
        });
    }
});

App.W.on('resize', function () {
    if (App.H.hasClass('page-products-store') && App.H.find('.js-filter-search-mobile')) {
        if (App.W.outerWidth() < 768) {
            $('.js-filter-search-mobile').find('.js-input').removeAttr('disabled');
        } else {
            $('.js-filter-search-mobile').find('.js-input').attr('disabled', true);
        }
    }
});
